'use strict';

const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const InvitationEditView = require('balus/ui/view/body/group/modal/invitation-edit');
const Template = require('balus/ui/template/body/group/sidebar/invitation-list.hbs');
const InvitationItemEmptyTemplate = require('balus/ui/template/body/group/sidebar/invitation-item-empty.hbs');
const InvitingItemTemplate = require('balus/ui/template/body/group/sidebar/invitation-item-inviting.hbs');
const JoinedItemTemplate = require('balus/ui/template/body/group/sidebar/invitation-item-joined.hbs');
const ModalView = require('common/ui/view/modal/index');
const i18n = require('i18next');

const InvitationItemEmptyView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item invitation-list-item',
    template: InvitationItemEmptyTemplate
});

const InvitingView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item inviting-list-item',
    template: InvitingItemTemplate
});

const InvitingListView = Mn.CollectionView.extend({
    tagName: 'li',
    className: 'list list-bordered inviting-list',
    childView: InvitingView,
    emptyView: InvitationItemEmptyView,
    filter: function(child) {
        return !child.get('joined_at') && child.get('created_at');
    }
});

const JoinedView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item joined-list-item',
    template: JoinedItemTemplate
});

const JoinedListView = Mn.CollectionView.extend({
    tagName: 'li',
    className: 'list list-bordered joined-list',
    childView: JoinedView,
    emptyView: InvitationItemEmptyView,
    filter: function(child) {
        return child.get('joined_at') && child.get('created_at');
    }
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        editButton: '.edit'
    },
    events: {
        'click @ui.editButton': 'edit'
    },
    regions: {
        invitingList: '.inviting-list-wrapper',
        joinedList: '.joined-list-wrapper',
    },
    modelEvents: {
        'change:member_invitations': 'render'
    },

    onRender: function() {
        // inviting 一覧
        this.showChildView('invitingList', new InvitingListView({
            collection: new Backbone.Collection(
                this.model.get('member_invitations'))
        }));

        // joined 一覧
        this.showChildView('joinedList', new JoinedListView({
            collection: new Backbone.Collection(
                this.model.get('member_invitations'))
        }));
    },
    edit: function() {
        const modal = new ModalView({
            title: i18n.t('balus_template_body_group:modal.registration.title'),
            bodyView: new InvitationEditView({
                model: this.model,
                collection: new Backbone.Collection(
                    this.model.get('member_invitations'))
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    })
                    .catch(() => {
                        this.enableButtons();
                    });
            }
        });
        modal.show();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/sidebar/invitation-list.js